/*jshint strict: false */
(
    function (window, document, $, _, undefined) {
        function updateRegions(e) {
            var countrySelect = $('#country'),
                regionSelect = $('#region'),
                selectedCountry = countrySelect.val(),
                regionLabel = $('label[for="region"]');

            if (_.isEmpty(selectedCountry)) {
                regionSelect.attr('disabled', 'disabled')
                    .attr('aria-disabled', 'true')
                    .prop('disabled', true);
            } else {
                if (regionSelect.is(':disabled')) {
                    regionSelect.removeAttr('disabled')
                        .attr('aria-disabled', 'false')
                        .prop('disabled', false);
                }

                regionSelect.find('optgroup').detach();

                window.regionOptGroups.each(
                    function () {
                        var optGroup = $(this);

                        if (optGroup.data('code') === _.parseInt(selectedCountry)) {
                            regionSelect.append($(this));
                        }
                    }
                );

                if (!_.isUndefined(e)) {
                    regionSelect.find(':selected').removeAttr('selected');
                    regionSelect.val('');

                    if (countrySelect.find(':selected').data('abbr').toLowerCase() === 'ca') {
                        regionSelect.find(':selected').text('Province/Territory*');
                        regionLabel.text('Province/Territory*');
                    } else if (countrySelect.find(':selected').data('abbr').toLowerCase() === 'us') {
                        regionSelect.find(':selected').text('State/Territory*');
                        regionLabel.text('State/Territory*');
                    }
                }
            }
        }

        function updateProduct(e) {
            var countrySelect = $('#country'),
                selectedCountry = countrySelect.val(),
                productName = $('#productName');

            if (_.isEmpty(selectedCountry)) {
                productName.text('');
            } else {
                if (countrySelect.find(':selected').data('abbr').toLowerCase() === 'ca') {
                    productName.text('Prevail™');
                } else if (countrySelect.find(':selected').data('abbr').toLowerCase() === 'us') {
                    productName.text('Rescue™');
                }
            }
        }

        $(document).ready(
            function () {
                var countrySelect = $('#country'),
                    regionSelect = $('#region');

                window.regionOptGroups = regionSelect.find('optgroup').detach();

                updateRegions();

                countrySelect.on(
                    'change.one-health',
                    updateRegions
                );

                countrySelect.on(
                    'change.one-health',
                    updateProduct
                );
            }
        );
    }
)(window, document, window.jQuery, window._);
